import "./user.css";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUsers, updateUser } from "../../redux/apiCalls";
import moment from "moment";
import Table from "../../components/advancedTable";
import Select from "react-select";

const statusOptions = [
    {
        label: "Inactive",
        value: "inactive",
    },
    {
        label: "Active",
        value: "active",
    },
    {
        label: "All",
        value: "",
    },
];

const typeOptions = [
    {
        label: "All",
        value: "",
    },
    {
        label: "User",
        value: "user",
    },
    {
        label: "Outright",
        value: "outright",
    },
    {
        label: "HQ",
        value: "HQ",
    },
    {
        label: "Salesperson",
        value: "salesperson",
    },
];

export default function User() {
    const dispatch = useDispatch();
    const currentUser = useSelector((state) => state.user.currentUser);
    const isHQ = currentUser?.type === "HQ";
    
    // eslint-disable-next-line
    const [inputs, setInputs] = useState({
        status: "active",
        type: isHQ ? "" : "user",
        limit: 20,
        page: 1,
        name: undefined
    });
    const [user, setUser] = useState(undefined);
    const [name, setName] = useState(undefined);
    const [editModalState, setEditModalState] = useState(false);
    const [statusModalState, setStatusModalState] = useState(false);
    const [selectedUser, setSelectedUser] = useState(undefined);
    const [usersData, setUsersData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        const fetchData = async () => {

                try {
                    const result = await getUsers(dispatch, inputs);
                    setUsersData(result ? result.users : []);
                    setTotalPages(result.totalPages);
                    setIsLoaded(true);
                } catch (error) {
                    console.error("Error fetching users:", error);
                }
            }

        if (isLoaded === false) {
        fetchData();
    };
        //eslint-disable-next-line
    }, [dispatch, inputs]);

    const handleChange = (e) => {
        setUser((prev) => {
            return { ...prev, [e.target.name]: e.target.value };
        });
    };

    const handleChangeAddress = (e) => {
        setUser((prev) => {
            return {
                ...prev,
                address: { ...prev.address, [e.target.name]: e.target.value },
            };
        });
    };

    const handleNameChange = (e) => {
        setIsLoaded(false);
        setInputs((prev) => {
            return { ...prev, page: 1, name: e.target.value };
        });
        setName(e.target.value);
    };

    const handleInputStatus = (e) => {
        setIsLoaded(false);
        setInputs((prev) => {
            return { ...prev, page: 1, status: e.value };
        });
    };

    const handleInputType = (e) => {
        setIsLoaded(false);
        setInputs((prev) => {
            return { ...prev, page: 1, type: e.value };
        });
    };

    const handleClick = async () => {
        // Create a copy of the user object
        const userToUpdate = { ...user };
        
        // Remove password field if it's empty, undefined, or not provided
        if (!userToUpdate.password || userToUpdate.password.trim() === '') {
            delete userToUpdate.password;
        }
    
        updateUser(user._id, userToUpdate, dispatch);
    };

    const handleStatusChange = async (newStatus) => {
        const userToUpdate = {
            ...selectedUser,
            status: newStatus,
        };
        
        // Remove password field
        delete userToUpdate.password;
        
        await updateUser(selectedUser._id, userToUpdate, dispatch);
        setStatusModalState(false);
        setIsLoaded(false);
    };

    const columns = [
        {
            accessor: "name",
            Header: "Name",
            width: 400,
            sortable: false,
        },
        {
            accessor: "phoneNumber",
            Header: "Phone Number",
            width: 200,
            sortable: false,
        },
        {
            accessor: "emailAddress",
            Header: "Email",
            width: 300,
            sortable: false,
            Cell: ({ value }) => (
                <div className="">{value ? value : ""}</div>
            ),
        },
        {
            accessor: "email",
            Header: "Username",
            width: 400,
            sortable: false,
            Cell: ({ value }) => (
                <div className="">{value ? value : ""}</div>
            ),
        },
        {
            accessor: "type",
            Header: "Type",
            width: 150,
            sortable: false,
            Cell: ({ value }) => (
                <div className="capitalize">{value}</div>
            ),
        },
        {
            accessor: "status",
            Header: "Status",
            width: 200,
            sortable: false,
            Cell: ({ value }) => (
                <div className="capitalize">{value}</div>
            ),
        },
        {
            accessor: "createdAt",
            Header: "Member Since",
            width: 200,
            sortable: false,
            Cell: ({ value }) => (
                <div className="capitalize">
                    {moment(value).format("DD/MM/YYYY")}
                </div>
            ),
        },
        {
            accessor: "action",
            Header: "Action",
            width: 200,
            sortable: false,
            Cell: (params) => {
                return (
                    <div className="flex items-center justify-center gap-2 whitespace-nowrap">
                        <button
                            className="px-4 py-2 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white font-medium rounded-xl shadow-lg transition-all duration-300 transform hover:scale-105 hover:shadow-xl border border-blue-500 whitespace-nowrap"
                            onClick={() => {
                                setUser(params.row.original);
                                window.scrollTo(0, 0);
                                setEditModalState(true);
                            }}
                        >
                            ✏️ Edit
                        </button>
                        <button
                            className="px-4 py-2 bg-gradient-to-r from-purple-600 to-purple-700 hover:from-purple-700 hover:to-purple-800 text-white font-medium rounded-xl shadow-lg transition-all duration-300 transform hover:scale-105 hover:shadow-xl border border-purple-500 whitespace-nowrap"
                            onClick={() => {
                                setSelectedUser(params.row.original);
                                window.scrollTo(0, 0);
                                setStatusModalState(true);
                            }}
                        >
                            🔄 Status
                        </button>
                    </div>
                );
            },
        },
    ];

    return (
        <>
            <div className="w-full bg-gradient-to-br from-slate-50 to-blue-50 min-h-screen">
                <div className="productList bg-white rounded-3xl shadow-2xl p-8 m-6 border border-slate-200/50">
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
                        <div className="space-y-2">
                            <label className="text-sm font-semibold text-slate-700 tracking-wide">User Name</label>
                            <div className="luxury-input-wrapper">
                                <input
                                    className="w-full px-4 py-3 bg-gradient-to-r from-slate-50 to-blue-50 border-2 border-slate-200 rounded-xl focus:border-blue-500 focus:ring-4 focus:ring-blue-100 transition-all duration-300 font-medium text-slate-700 placeholder-slate-400"
                                    name="name"
                                    value={name}
                                    type="string"
                                    placeholder="Search by name"
                                    onChange={handleNameChange}
                                    style={{
                                        background: 'linear-gradient(to right, rgb(248 250 252), rgb(239 246 255))',
                                        border: '2px solid rgb(226 232 240)',
                                        borderRadius: '12px',
                                        padding: '12px 16px',
                                        fontSize: '14px',
                                        fontWeight: '500',
                                    }}
                                />
                            </div>
                        </div>
                        <div className="space-y-2">
                            <label className="text-sm font-semibold text-slate-700 tracking-wide">User Status</label>
                            <div className="luxury-select-wrapper">
                                <Select
                                    options={statusOptions.map((status, i) => {
                                        return {
                                            label: status.label,
                                            value: status.value,
                                        };
                                    })}
                                    onChange={handleInputStatus}
                                    placeholder="Select Status"
                                    styles={{
                                        control: (base) => ({
                                            ...base,
                                            background: 'linear-gradient(to right, rgb(248 250 252), rgb(239 246 255))',
                                            border: '2px solid rgb(226 232 240)',
                                            borderRadius: '12px',
                                            padding: '6px',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            boxShadow: 'none',
                                            '&:hover': {
                                                borderColor: 'rgb(59 130 246)',
                                            }
                                        }),
                                        option: (base, state) => ({
                                            ...base,
                                            backgroundColor: state.isSelected ? 'rgb(59 130 246)' : state.isFocused ? 'rgb(239 246 255)' : 'white',
                                            color: state.isSelected ? 'white' : 'rgb(51 65 85)',
                                            fontWeight: '500',
                                            '&:hover': {
                                                backgroundColor: 'rgb(239 246 255)',
                                            }
                                        })
                                    }}
                                />
                            </div>
                        </div>
                        {isHQ && (
                            <div className="space-y-2">
                                <label className="text-sm font-semibold text-slate-700 tracking-wide">User Type</label>
                                <div className="luxury-select-wrapper">
                                    <Select
                                        options={typeOptions.map((type, i) => {
                                            return {
                                                label: type.label,
                                                value: type.value,
                                            };
                                        })}
                                        onChange={handleInputType}
                                        placeholder="Select Type"
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                background: 'linear-gradient(to right, rgb(248 250 252), rgb(239 246 255))',
                                                border: '2px solid rgb(226 232 240)',
                                                borderRadius: '12px',
                                                padding: '6px',
                                                fontSize: '14px',
                                                fontWeight: '500',
                                                boxShadow: 'none',
                                                '&:hover': {
                                                    borderColor: 'rgb(59 130 246)',
                                                }
                                            }),
                                            option: (base, state) => ({
                                                ...base,
                                                backgroundColor: state.isSelected ? 'rgb(59 130 246)' : state.isFocused ? 'rgb(239 246 255)' : 'white',
                                                color: state.isSelected ? 'white' : 'rgb(51 65 85)',
                                                fontWeight: '500',
                                                '&:hover': {
                                                    backgroundColor: 'rgb(239 246 255)',
                                                }
                                            })
                                        }}
                                    />
                                </div>
                            </div>
                        )}
                    </div>

                    <Table
                        data={usersData ? usersData : []}
                        columns={columns}
                        pageCount={Math.floor(totalPages / 20) + 2}
                        totalCount={totalPages}
                        updatePagination={setInputs}
                        paginationState={inputs}
                        updateLoaded={setIsLoaded}
                        hidePagination={inputs.limit === 20 ? false : true}
                    />
                </div>
            </div>

            {editModalState && (
                <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4">
                    <div className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto border border-slate-200">
                        <div className="sticky top-0 bg-white rounded-t-2xl border-b border-slate-200 p-6 z-10">
                            <div className="flex justify-between items-center">
                                <h2 className="text-2xl font-bold text-slate-800">Edit User</h2>
                                <button
                                    onClick={() => setEditModalState(false)}
                                    className="text-gray-400 hover:text-gray-600 transition-colors duration-200"
                                >
                                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                        
                        <div className="p-6">
                            <form className="space-y-6">
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    <div className="space-y-2">
                                        <label className="text-sm font-semibold text-slate-700">Full Name</label>
                                        <input
                                            name="name"
                                            type="text"
                                            placeholder={user?.name || "Enter full name"}
                                            onChange={handleChange}
                                            className="w-full px-4 py-3 bg-gradient-to-r from-slate-50 to-blue-50 border-2 border-slate-200 rounded-xl focus:border-blue-500 focus:ring-4 focus:ring-blue-100 transition-all duration-300 font-medium text-slate-700 placeholder-slate-400"
                                        />
                                    </div>
                                    <div className="space-y-2">
                                        <label className="text-sm font-semibold text-slate-700">Username</label>
                                        <input
                                            name="email"
                                            type="string"
                                            placeholder={user?.email || "Enter username"}
                                            onChange={handleChange}
                                            className="w-full px-4 py-3 bg-gradient-to-r from-slate-50 to-blue-50 border-2 border-slate-200 rounded-xl focus:border-blue-500 focus:ring-4 focus:ring-blue-100 transition-all duration-300 font-medium text-slate-700 placeholder-slate-400"
                                        />
                                    </div>
                                    <div className="space-y-2">
                                        <label className="text-sm font-semibold text-slate-700">Email</label>
                                        <input
                                            name="emailAddress"
                                            type="email"
                                            placeholder={user?.emailAddress || "Enter email"}
                                            onChange={handleChange}
                                            className="w-full px-4 py-3 bg-gradient-to-r from-slate-50 to-blue-50 border-2 border-slate-200 rounded-xl focus:border-blue-500 focus:ring-4 focus:ring-blue-100 transition-all duration-300 font-medium text-slate-700 placeholder-slate-400"
                                        />
                                    </div>
                                    <div className="space-y-2">
                                        <label className="text-sm font-semibold text-slate-700">Phone Number</label>
                                        <input
                                            name="phoneNumber"
                                            type="tel"
                                            placeholder={user?.phoneNumber || "Enter phone number"}
                                            onChange={handleChange}
                                            className="w-full px-4 py-3 bg-gradient-to-r from-slate-50 to-blue-50 border-2 border-slate-200 rounded-xl focus:border-blue-500 focus:ring-4 focus:ring-blue-100 transition-all duration-300 font-medium text-slate-700 placeholder-slate-400"
                                        />
                                    </div>
                                    <div className="space-y-2">
                                        <label className="text-sm font-semibold text-slate-700">Password</label>
                                        <input
                                            name="password"
                                            type="password"
                                            placeholder="Enter new password"
                                            onChange={handleChange}
                                            className="w-full px-4 py-3 bg-gradient-to-r from-slate-50 to-blue-50 border-2 border-slate-200 rounded-xl focus:border-blue-500 focus:ring-4 focus:ring-blue-100 transition-all duration-300 font-medium text-slate-700 placeholder-slate-400"
                                        />
                                    </div>
                                    <div className="space-y-2 md:col-span-2">
                                        <label className="text-sm font-semibold text-slate-700">Address Line One</label>
                                        <input
                                            name="lineOne"
                                            type="text"
                                            placeholder={user?.address?.lineOne || "Enter address line one"}
                                            value={user?.address?.lineOne ?? ""}
                                            onChange={handleChangeAddress}
                                            className="w-full px-4 py-3 bg-gradient-to-r from-slate-50 to-blue-50 border-2 border-slate-200 rounded-xl focus:border-blue-500 focus:ring-4 focus:ring-blue-100 transition-all duration-300 font-medium text-slate-700 placeholder-slate-400"
                                        />
                                    </div>
                                    <div className="space-y-2 md:col-span-2">
                                        <label className="text-sm font-semibold text-slate-700">Address Line Two</label>
                                        <input
                                            name="lineTwo"
                                            type="text"
                                            placeholder={user?.address?.lineTwo || "Enter address line two"}
                                            value={user?.address?.lineTwo ?? ""}
                                            onChange={handleChangeAddress}
                                            className="w-full px-4 py-3 bg-gradient-to-r from-slate-50 to-blue-50 border-2 border-slate-200 rounded-xl focus:border-blue-500 focus:ring-4 focus:ring-blue-100 transition-all duration-300 font-medium text-slate-700 placeholder-slate-400"
                                        />
                                    </div>
                                    <div className="space-y-2">
                                        <label className="text-sm font-semibold text-slate-700">Zipcode</label>
                                        <input
                                            name="zip"
                                            type="text"
                                            placeholder={user?.address?.zip || "Enter zipcode"}
                                            value={user?.address?.zip ?? ""}
                                            onChange={handleChangeAddress}
                                            className="w-full px-4 py-3 bg-gradient-to-r from-slate-50 to-blue-50 border-2 border-slate-200 rounded-xl focus:border-blue-500 focus:ring-4 focus:ring-blue-100 transition-all duration-300 font-medium text-slate-700 placeholder-slate-400"
                                        />
                                    </div>
                                    <div className="space-y-2">
                                        <label className="text-sm font-semibold text-slate-700">City</label>
                                        <input
                                            name="city"
                                            type="text"
                                            placeholder={user?.address?.city || "Enter city"}
                                            value={user?.address?.city ?? ""}
                                            onChange={handleChangeAddress}
                                            className="w-full px-4 py-3 bg-gradient-to-r from-slate-50 to-blue-50 border-2 border-slate-200 rounded-xl focus:border-blue-500 focus:ring-4 focus:ring-blue-100 transition-all duration-300 font-medium text-slate-700 placeholder-slate-400"
                                        />
                                    </div>
                                    <div className="space-y-2">
                                        <label className="text-sm font-semibold text-slate-700">Country</label>
                                        <input
                                            name="country"
                                            type="text"
                                            placeholder={user?.address?.country || "Enter country"}
                                            value={user?.address?.country ?? ""}
                                            onChange={handleChangeAddress}
                                            className="w-full px-4 py-3 bg-gradient-to-r from-slate-50 to-blue-50 border-2 border-slate-200 rounded-xl focus:border-blue-500 focus:ring-4 focus:ring-blue-100 transition-all duration-300 font-medium text-slate-700 placeholder-slate-400"
                                        />
                                    </div>
                                </div>
                            
                                
                                <div className="flex justify-end gap-4 pt-6 border-t border-slate-200">
                                    <button
                                        type="button"
                                        onClick={() => setEditModalState(false)}
                                        className="px-6 py-3 bg-gray-500 hover:bg-gray-600 text-white font-medium rounded-xl transition-colors duration-200"
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="button"
                                        onClick={handleClick}
                                        className="px-8 py-3 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white font-medium rounded-xl shadow-lg transition-all duration-300 transform hover:scale-105"
                                    >
                                        Update User
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}

            {statusModalState && (
                <div 
                    className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
                    onClick={() => setStatusModalState(false)}
                >
                    <div 
                        className="bg-white rounded-lg shadow-xl max-w-md w-full"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="p-6">
                            <h2 className="text-2xl font-bold text-gray-800 mb-6 text-center">Status</h2>
                            
                            <div className="space-y-4">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        Status
                                    </label>
                                    <Select
                                        options={[
                                            { label: "Active", value: "active" },
                                            { label: "Inactive", value: "inactive" },
                                        ]}
                                        onChange={(selectedOption) => {
                                            handleStatusChange(selectedOption.value);
                                        }}
                                        value={
                                            selectedUser?.status
                                                ? { 
                                                    label: selectedUser.status.charAt(0).toUpperCase() + selectedUser.status.slice(1), 
                                                    value: selectedUser.status 
                                                }
                                                : { label: "Active", value: "active" }
                                        }
                                        placeholder="Select Status"
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                borderColor: '#d1d5db',
                                                borderRadius: '0.375rem',
                                                padding: '0.25rem',
                                                fontSize: '14px',
                                                boxShadow: 'none',
                                                '&:hover': {
                                                    borderColor: '#9ca3af',
                                                }
                                            }),
                                            option: (base, state) => ({
                                                ...base,
                                                backgroundColor: state.isSelected 
                                                    ? '#3b82f6' 
                                                    : state.isFocused 
                                                    ? '#dbeafe' 
                                                    : 'white',
                                                color: state.isSelected ? 'white' : '#374151',
                                                '&:hover': {
                                                    backgroundColor: state.isSelected ? '#3b82f6' : '#dbeafe',
                                                }
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                borderRadius: '0.375rem',
                                                marginTop: '4px',
                                            })
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
